import React, { Component } from 'react';
import api from '../api/api';

import Account from '../components/account';
import Authorize from '../components/authorize';
import MedicalAid from '../components/medicalAid';
import Patient from '../components/patient';
import Product from '../components/product';
import Layout from '../components/layout';
import Report from '../components/report';
import Todo from '../components/todo';
import Visit from '../components/visit';


import {
  AppBar,
  Avatar,
  CircularProgress,
	CssBaseline,
  Divider,
	Drawer,
  IconButton,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
  Toolbar,
  Typography,
} from '@mui/material'

import { withStyles } from '@mui/styles';

import AccountBoxIcon from '@mui/icons-material/AccountBox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import CollectionsIcon from '@mui/icons-material/Collections';
import MenuIcon from '@mui/icons-material/Menu';
import NotesIcon from '@mui/icons-material/Notes';
import PersonIcon from '@mui/icons-material/Person';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import StorageIcon from '@mui/icons-material/Storage';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { authMiddleWare } from '../util/auth'


const ACCOUNT = 1;
const ASSESSMENT = 2;
const AUTHORIZE = 3;
const LAYOUT = 4;
const PATIENT = 5;
const MEDICAL_AID = 6;
const PRODUCT = 7;
const TODO = 8;
const VISIT = 9;
const REPORT = 10;

const drawerWidth = 240;

const styles = (theme) => ({
	root: {
		display: 'flex'
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1
	},
	submitButton: {
    display: 'block',
    color: 'white',
    textAlign: 'center',
    position: 'absolute',
    top: 14,
    right: 10,
  },
	drawer: {
		width: drawerWidth,
		flexShrink: 0
	},
	drawerPaper: {
		width: drawerWidth
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3)
	},
	avatar: {
		height: 110,
		width: 100,
		flexShrink: 0,
		flexGrow: 0,
		marginTop: 20
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	toolbar: theme.mixins.toolbar,
});

class Home extends Component {
	state = {
		render: false
	};

	loadAccountPage = () => {
		this.setState({ render: ACCOUNT,
			anchor: false 
		});
	};

  loadAssessPage = () => {
		this.setState({ render: ASSESSMENT,
			anchor: false 
		});
	};

  loadAuthPage = () => {
		this.setState({ render: AUTHORIZE,
			anchor: false 
		});
	};

	loadLayoutPage = () => {
		this.setState({ render: LAYOUT,
			anchor: false 
		});
	};

	loadMedicalAidPage = () => {
		this.setState({ render: MEDICAL_AID,
			anchor: false
		});
	};

	loadPatientPage = () => {
		this.setState({ render: PATIENT,
			anchor: false 
		});
	};

  loadProductPage = () => {
		this.setState({ render: PRODUCT,
			anchor: false 
		});
	};

  loadReportPage = () => {
		this.setState({ render: REPORT,
			anchor: false 
		});
	};

	loadTodoPage = () => {
		this.setState({ render: TODO,
			anchor: false 
		});
	};

	loadVisitPage = () => {
		this.setState({ render: VISIT,
			anchor: false
		});
	};

	logoutHandler = () => {
		localStorage.removeItem('AuthToken');
		localStorage.removeItem('TokenExpiry');
		this.props.history.push('/login');
	};

	constructor(props) {
		super(props);

		this.state = {
			anchor: true,
			country: 'RSA',
			email: '',
			firstName: '',
			groupId: '',
			imageLoading: false,
			isAdmin: false,
			lastName: '',
			phoneNumber: '',
			profilePicture: '',
			uiLoading: true,
			username: '',
		};
	}

	componentDidMount = () => {
		authMiddleWare(this.props.history);
		api
			.get('/user')
			.then((response) => {
				const creds = response.data.userCredentials
				const groupId = creds.groupId || ''
				const groupRoles = creds.groupRoles || {}
				this.setState({
					firstName: creds.firstName,
					lastName: creds.lastName,
					email: creds.email,
					phoneNumber: creds.phoneNumber,
					country: creds.country,
					groupId,
					isAdmin: groupRoles[groupId] === 'admin',
					username: creds.username,
					uiLoading: false,
					profilePicture: creds.imageUrl
				});
			})
			.catch((error) => {
				if (error.response && (error.response.status === 401 || error.response.status === 403)) {
					this.props.history.push('/login')
				}
				console.log(error);
				this.setState({ errorMsg: 'Error in retrieving the data', uiLoading: false });
			});
	};

	toggleDrawer = () => {
		const anchor = (!this.state.anchor);
		this.setState({anchor});
	}
	
	render() {
		const { classes } = this.props;
		const { username, groupId } = this.state
//		const { classes, anchor } = this.props;	
//		const toggleDrawer = () => this.setState({anchor:!anchor})
	
    let focus = null;
//		const username = this.state.username === '' ? "dummy" : this.state.username
//		const groupId = this.state.groupId === '' ? "dummy" : this.state.groupId
    switch (this.state.render) {
      case ACCOUNT:
        focus = <Account />;
        break;
      case AUTHORIZE:
        focus = (
					<div>
						<Authorize groupId={groupId}/>
					</div>
				)
        break
      case LAYOUT:
        focus = <Layout />;
        break;
			case MEDICAL_AID:
				focus = <MedicalAid isAdmin={this.state.isAdmin} />;
				break;
      case PATIENT:
        focus = <Patient groupId={groupId}/>;
        break;
      case PRODUCT:
        focus = <Product groupId={groupId}/>;
        break;
      case REPORT:
        focus = <Report groupId={groupId}/>;
        break;
      case TODO:
        focus = <Todo username={username} groupId={groupId} />;
        break;
      case VISIT:
        focus = <Visit username={username} groupId={groupId} isAdmin={this.state.isAdmin} />;
        break;
      default:
				focus = <div />;
    } 
		if (this.state.uiLoading === true) {
			return (
				<div className={classes.root}>
					{this.state.uiLoading && <CircularProgress size={150} className={classes.uiProgess} />}
				</div>
			);
		} else {
			return (
				<div className={classes.root}>
					<CssBaseline />
					<AppBar position="fixed" className={classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Menu"
								onClick={this.toggleDrawer}
								size="large"
							>
								<MenuIcon />
							</IconButton>
							<Typography variant="h6" noWrap>
								Wound Care
							</Typography>
						</Toolbar>
					</AppBar>
					<Drawer
						className={classes.drawer}
						variant="temporary"
						open={this.state.anchor} 
						classes={{
							paper: classes.drawerPaper
						}}
					>
						<List>
							<ListItem button key="Close" onClick={this.toggleDrawer}>
								<ListItemIcon>
									<CloseIcon />
								</ListItemIcon>
							</ListItem>
						</List>
						<Divider />
						<center>
							<Avatar src={this.state.profilePicture} className={classes.avatar} />
							<p>
								{' '}
								{this.state.firstName} {this.state.lastName}
							</p>
						</center>
						<Divider />
						<List>
							<ListItem button key="Auth" onClick={this.loadAuthPage}>
								<ListItemIcon>
									{' '}
									<CheckCircleIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Authorizations" />
							</ListItem>

							<ListItem button key="Visit" onClick={this.loadVisitPage}>
								<ListItemIcon>
									{' '}
									<StorageIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Visits" />
							</ListItem>

							<ListItem button key="Report" onClick={this.loadReportPage}>
								<ListItemIcon>
									{' '}
									<SaveAltIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Reports" />
							</ListItem>

							<ListItem button key="Patient" onClick={this.loadPatientPage}>
								<ListItemIcon>
									{' '}
									<PersonIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Patients" />
							</ListItem>

							<ListItem button key="Product" onClick={this.loadProductPage}>
								<ListItemIcon>
									{' '}
									<CollectionsIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Products" />
							</ListItem>

							{/* <ListItem button key="Visit (History)" onClick={this.loadVHistPage}>
								<ListItemIcon>
									{' '}
									<StorageIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Visits (hist.)" />
							</ListItem>
 */}
							<ListItem button key="Todo" onClick={this.loadTodoPage}>
								<ListItemIcon>
									{' '}
									<NotesIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Scribbles" />
							</ListItem>

							<ListItem button key="MedicalAid" onClick={this.loadMedicalAidPage}>
								<ListItemIcon>
									{' '}
									<LocalHospitalIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Medical Aids" />
							</ListItem>

							<ListItem button key="Account" onClick={this.loadAccountPage}>
								<ListItemIcon>
									{' '}
									<AccountBoxIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Account" />
							</ListItem>

							<ListItem button key="Logout" onClick={this.logoutHandler}>
								<ListItemIcon>
									{' '}
									<ExitToAppIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Logout" />
							</ListItem>
						</List>
					</Drawer>

					<div>{focus}</div>
				</div>
      );
		}
	}
}

export default withStyles(styles)(Home);